import { Shield, Clock, Award, Building2, Users } from 'lucide-react';
import ScrollReveal from '@/components/ScrollReveal';

const trustItems = [
  { icon: Clock, text: '60+ Years Combined Experience' },
  { icon: Shield, text: 'Enterprise-Grade Security' },
  { icon: Award, text: 'Production-Ready AI' },
  { icon: Building2, text: 'Regulated Industry Expertise' },
  { icon: Users, text: 'Founder-Led Delivery' },
];

export default function TrustStrip() {
  // Duplicate items for seamless loop
  const allItems = [...trustItems, ...trustItems];

  return (
    <section className="bg-white py-6 overflow-hidden">
      <ScrollReveal direction="up" distance={20}>
        <div className="relative">
          {/* Gradient Masks */}
          <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-white to-transparent z-10" />
          <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-white to-transparent z-10" />

          {/* Ticker */}
          <div className="flex animate-ticker hover:[animation-play-state:paused]">
            {allItems.map((item, index) => (
              <div
                key={index}
                className="flex items-center gap-3 px-8 whitespace-nowrap"
              >
                <item.icon className="w-5 h-5 text-primary" />
                <span className="text-sm font-medium text-slate-600">
                  {item.text}
                </span>
              </div>
            ))}
          </div>
        </div>
      </ScrollReveal>
    </section>
  );
}
